var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.VisibilityObserver = (function () {
    // Class name to observe - render when element is marked as visible, not when it necessarily is visible to the user
    let observedClass = 'js-render-when-visible';
    let customProperty = '--viewport-drivenstate';
    let doNotRender = 'do-not-render';
    let observer;

    // Public API
    return {
        determineItemsToLoad: determineItemsToLoad,
        performOperationOnViewportChanges: performOperationOnViewportChanges
    };

    // Initialization function
    function performOperationOnViewportChanges(callback) {
        // Create an Intersection Observer
        observer = new IntersectionObserver(onChange);

        // Function to handle method cal changes
        function onChange(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && shouldLoadElement(entry.target)) {
                    // Call the provided callback method when the element becomes visible
                    callback(entry.target);

                    // Unobserve the element
                    observer.unobserve(entry.target);
                }
            });
        }

        // Select all elements with the specified class
        let elementsToObserve = Array.from(document.getElementsByClassName(observedClass));
        elementsToObserve.forEach(element => {
            if (!isElementStateSetToRender(element)) {
                observer.observe(element);
            }
        });
    }

    function filterElementsToLoad(domItems) {
        //Make sure it is a jquery filter so it is (index, item) - not an array which takes (element,index)
        return $(domItems).filter((index, item) => {
            const requiresVisibility = elementRequiresVisibility(item);
            const isStateSetToRender = isElementStateSetToRender(item);
            return !requiresVisibility || isStateSetToRender;
        });
    }

    function shouldLoadElement(item) {
        const requiresVisibility = elementRequiresVisibility(item);
        const isStateSetToRender = isElementStateSetToRender(item);
        return requiresVisibility && isStateSetToRender;
    }

    function isElementStateSetToRender(element) {
        parentElementToCheck = findParentWithClass(element, observedClass)
        if (parentElementToCheck.length > 0) {
            element = parentElementToCheck[0];
        }

        if (!(element)) {
            return false;
        }

        const style = window.getComputedStyle(element);
        const isStateSetToRender = (style.getPropertyValue(customProperty).trim() !== doNotRender);

        return isStateSetToRender;
    }

    function findParentWithClass(element, classToFind) {
        return $(element).parents('.' + classToFind).first();
    }

    function elementRequiresVisibility(element) {
        return (findParentWithClass(element, observedClass).length > 0) || $(element).hasClass(observedClass);
    }

    function determineItemsToLoad(domItems, elementClass) {
        if (!domItems) {
            domItems = $(elementClass);
        } else {
            domItems = $(domItems).filter(elementClass).add($(domItems).find(elementClass));
        }

        if ((typeof App !== 'undefined') && App.renderWhenVisible) {
            domItems = filterElementsToLoad($(domItems));
        }
        return $(domItems);
    };

})(jQuery);

$(document).ready(function () {
    if ((typeof App !== 'undefined') && App.renderWhenVisible) {
        SCM.SharedWidgets.VisibilityObserver.performOperationOnViewportChanges(function (element) {
            // Load the widget when the element becomes visible - in case view ports change
            var elementArray = element ? [element] : null;
            SCM.SharedWidgets.AsyncWidgetLoader.LoadWidget('.SCM-SharedWidgets-AsyncWidgetLoader', 'data-url', 'data-params', 'POST', elementArray);
            SCM.AsyncAds.LoadJobsAd('.SCM-SharedWidgets-AsyncJobsAdLoader', 'data-url', 'data-params', 'POST', elementArray);
            SCM.AsyncAds.LoadAds('.SCM-SharedWidgets-AsyncAdLoader', 'data-url', 'data-params', 'POST', elementArray);
        });
    }
});